import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { PlatformService } from '../../services/platform.service'

@Component({
  selector: 'app-pwa-prompt',
  templateUrl: './pwa-prompt.component.html',
  styleUrls: ['./pwa-prompt.component.scss'],
})
export class PwaPromptComponent {
  isIos: boolean
  isAndroid: boolean
  isRunningAsPWA: boolean
  clicked = false
  constructor(
    private router: Router,
    private platformService: PlatformService,
  ) {
    this.isIos = this.platformService.isIOS()
    this.isAndroid = this.platformService.isAndroid()
    this.isRunningAsPWA = this.platformService.isRunningAsPWA()
  }

  navigateToIOSInstructions() {
    this.router.navigate(['pwa-instructions'])
    this.clicked = true
  }
}
